<template>
  <div class="app color333">
    <div class="header">
      <!-- <template v-if="userInfo">
      <div>
        <img v-if="userInfo.headerImage" :src="userInfo.headerImage" alt="">
        <img v-else src="../assets/images/default-icon.png" alt="">
      </div>
      <div class="colorfff margin20">{{userInfo.name}}</div>
      </template>-->
    </div>
    <div class="user-info">
      <template v-if="childInfo.length>0">
        <div class="select-watch" @click="selectWatch">
          {{activeChildInfo.id?activeChildInfo.name : '未绑定'}}
          <img
            src="../assets/images/arrow-down.png"
          />
        </div>
        <div v-if="showSelect" class="watch-list">
          <div
            class="watch-list-item active"
            @click="selectChild(index)"
            v-for="(item,index) in childInfo"
            :key="index"
          >用户{{index+1}}</div>
        </div>
        <div class="infolist">
          <div class="infolist-item">
            <div class="infolist-item-number">{{activeChildInfo.integral || 0}}</div>
            <div class="infolist-item-key">剩余积分</div>
          </div>
          <div class="infolist-item">
            <div class="infolist-item-number">{{activeChildInfo.taskIntegral || 0}}</div>
            <div class="infolist-item-key">任务积分</div>
          </div>
          <div class="infolist-item" @click="goNextPage('/clockin')">
            <div class="infolist-item-number">{{activeChildInfo.taskCount || 0}}</div>
            <div class="infolist-item-key">今日任务</div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="no-child-tip color999">请绑定您孩子的手表，查看和定制符合您孩子发展的任务哦</div>
        <!-- <div class="btn-scan bg-green" @click="scan">扫码添加手表</div> -->
      </template>
    </div>
    <div class="go-list">
      <div class="go-list-item" @click="goNextPage('/mywatch')">
        <div>我的手表</div>
        <div>
          <img src="../assets/images/right-arrow.png" style="width:9px;height:16px" alt />
        </div>
      </div>
      <!-- <div class="go-list-item" @click="goNextPage('/userinfo')">
      <div>个人信息</div>
      <div><img src="../assets/images/right-arrow.png" style="width:9px;height:16px" alt=""></div>
    </div>
    <div class="go-list-item" @click="goNextPage('/record')">
      <div>我的积分</div>
      <div><img src="../assets/images/right-arrow.png" style="width:9px;height:16px" alt=""></div>
      </div>-->
    </div>
    <!-- <van-button type="primary" class="btn-logout bg-green" @click="loginout">退出</van-button> -->
    <Footer></Footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast } from "vant";
import { logout } from "../api/api-app";
import { listChildInfo } from "../api/api-child";
import Footer from "../components/Footer";

export default {
  name: "home",
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    }),
    childInfo: {
      get() {
        return this.$store.state.childInfo;
      },
      set(val) {
        this.$store.state.childInfo = val;
      }
    },
    activeChildInfo: {
      get() {
        return this.$store.state.activeChildInfo;
      },
      set(val) {
        this.$store.state.activeChildInfo = val;
      }
    }
  },
  components: { Footer },
  data() {
    return {
      showSelect: false,
      activeChildIndex: 0
    };
  },
  mounted() {
    this.getChildInfo();
  },
  methods: {
    getChildInfo() {
      let _this=this;
      let query="?"
        let openId=["be3ed123aa6e4b6dbb26f011cf82a7c7"]
        // let openId=["e89e0a498afd41e2bd9d493a4182f5f2"]
        openId.forEach((element,index) => {
          if(index == openId.lenth-1){
            query += "openIds="+element
          }else{
            query += "openIds="+element+"&"
          }
        });
        listChildInfo(query).then(res => {
          res.data.forEach((item,index)=>{
             item.name="用户"+(index+1)
           })
          if (res.code == 200) {
            if (res.data.length>0){
              _this.$store.dispatch("setChildInfo",res.data);
              for(var i=0;i<_this.childInfo.length;i++){
                if(_this.childInfo[i].id==_this.activeChildInfo.id){
                  _this.$store.dispatch("setActiveChildInfo",_this.childInfo[i]);
                }
              }
            } else {
              Toast.fail(res.msg);
              _this.$store.dispatch("setChildInfo",[]);
              _this.$store.dispatch("setActiveChildInfo",{});
            }
          }else{
            Toast.fail(res.msg)
          }
        })
      // 获取openid
      // let _this = this;
      // xtc.getOpenId({
      //   appId: "100020",
      //   success: function(data) {
      //     // 成功回调
      //     //测试用数据
      //     let query = "?";
      //     let openId = data.openId;
      //     openId.forEach((element, index) => {
      //       if (index == openId.length - 1) {
      //         query += "openIds=" + element;
      //       } else {
      //         query += "openIds=" + element + "&";
      //       }
      //     });
      //     listChildInfo(query).then(res => {
      //       if (res.code == 200) {
      //         if (res.data.length > 0) {
      //           res.data.forEach((item, index) => {
      //             item.name = "用户" + (index + 1);
      //           });
      //           _this.$store.dispatch("setChildInfo", res.data);
      //           for (var i = 0; i < _this.childInfo.length; i++) {
      //             if (_this.childInfo[i].id == _this.activeChildInfo.id) {
      //               _this.$store.dispatch(
      //                 "setActiveChildInfo",
      //                 _this.childInfo[i]
      //               );
      //             }
      //           }
      //         } else {
      //           Toast.fail(res.msg);
      //           _this.$store.dispatch("setChildInfo", []);
      //           _this.$store.dispatch("setActiveChildInfo", {});
      //         }
      //       } else {
      //         Toast.fail(res.msg);
      //       }
      //     });
      //   },
      //   fail: function(data, code) {
      //     // 失败回调
      //     console.log("fail:", data, code);
      //     Toast.fail(data);
      //   }
      // });
    },
    selectWatch() {
      this.showSelect = !this.showSelect;
    },
    selectChild(index) {
      this.$store.dispatch("setActiveChildInfo", this.childInfo[index]);
      this.activeChildIndex = index;
      this.showSelect = false;
    },
    scan() {},
    loginout() {
      logout().then(res => {
        if (res.code == 200) {
          localStorage.clear();
          this.$router.push("/login");
        } else {
          localStorage.clear();
        }
      });
    },
    goNextPage(url) {
      this.$router.push(url);
    }
  }
};
</script>
<style scoped>
.app {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #ecf0f5;
}
/**index.wxss**/
.header {
  height: 130px;
  padding: 25px 20px 0 25px;
  font-size: 20px;
  display: flex;
  background-image: url("../assets/images/index-bg.png");
}
.select-watch img {
  display: inline-template;
  width: 12px;
  height: 6px;
}
.margin20 {
  margin-top: 25px;
  margin-left: 15px;
}
.header img {
  width: 65px;
  height: 65px;
  border-radius: 50%;
}
.user-info {
  position: absolute;
  top: 105px;
  padding: 10px 0 15px 0;
  width: 345px;
  left: 15px;
  background: #fff;
  box-shadow: 0px 2px 3px 0px rgba(225, 230, 235, 1);
  border-radius: 12px;
}
.infolist {
  display: flex;
}
.infolist-item {
  flex: 1;
  text-align: center;
}
.select-watch {
  margin-left: 20px;
  font-size: 12px;
}
.infolist-item-number {
  font-size: 30px;
  font-weight: 400;
}
.infolist-item-key {
  font-size: 12px;
}
.go-list {
  padding-top: 50px;
  background: #fff;
  padding-bottom: 1px;
}
.go-list-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 0 15px;
  min-height: 16px;
}
.btn-logout {
  position: fixed;
  bottom: 80px;
  width: 335px;
  left: 20px;
  color: #fff;
  font-size: 16px;
  border-radius: 22px;
  background: #87e2cd;
  border: none;
}
.btn-logout::after {
  border: none;
}

.watch-list {
  position: absolute;
  z-index: 2;
  left: 10px;
  background: #fff;
  width: 75px;
  box-shadow: 0px 1px 3px 0px rgba(215, 221, 227, 1);
  border-radius: 3px;
  top: 30px;
}
.watch-list-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 10px;
  min-height: 16px;
}
.no-child-tip {
  font-size: 14px;
  padding: 5px 10px;
  line-height: 20px;
}

.btn-scan {
  width: 200px;
  color: #fff;
  font-size: 16px;
  border-radius: 22px;
  text-align: center;
  height: 36px;
  line-height: 36px;
  margin: 0 auto;
}
.btn-scan::after {
  border: none;
}
</style>
